import { useEffect } from "react";
import HeaderWeeklyReport from "../../../../Components/ComponentsIndustry/HeaderWeeklyReport";
import Loading from "../../../../Components/Loading";
import { useReportWeeklyIndustry } from "../../../../providers/ReportWeeklyIndustry";
import { useUser } from "../../../../providers/UserContext";

import {
  Container,
  SizeContainer,
  RoundContainer,
  H2RoundContainer,
  ParagraphRoundContainer,
  MainRoundContainer,
} from "./style";

const WeeklyReportProduction = () => {
  const { industry, jogo } = useUser()
  const { reportWeeklyIndustry, loading, fetchReportWeeklyIndustry, setReportWeeklyIndustry } = useReportWeeklyIndustry()

  useEffect(() => {
    setReportWeeklyIndustry({
      purchases: [],
      pcp: [],
      productions: [],
      salesInProgress: [],
      salesDone: []
    })
    if (!industry || !jogo) return
    fetchReportWeeklyIndustry()
  }, [industry, jogo])

  return (
    <Container>
      <SizeContainer>
        <HeaderWeeklyReport selected={["", "", "selection", ""]} />
        {loading ? (
          <RoundContainer>
            <Loading />
          </RoundContainer>

        ) : reportWeeklyIndustry?.productions?.length === 0 ? (
          <RoundContainer style={{ justifyContent: 'center' }}>
            <p style={{ fontSize: 20, fontWeight: 'bold' }}>Nenhum produto produzido.</p>
          </RoundContainer>
        ) : null
        }
        {reportWeeklyIndustry?.productions?.map((production, index) => {
          return (
            <RoundContainer key={index}>
              <H2RoundContainer>
                RODADA {production[0]?.rodada?.numero}
                <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
              </H2RoundContainer>
              <ParagraphRoundContainer>
                Produção
                <img src="./images/productions_1.svg" alt="productions_1" />
              </ParagraphRoundContainer>
              <MainRoundContainer>

                {production?.map((item, index) => {
                  let imageURL = null
                  if (item?.produto?.nome === "Peito de Frango") {
                    imageURL = "./images/chicken_pcp.svg"
                  } else if (item?.produto?.nome === "Coxa de Frango") {
                    imageURL = "./images/cut_chicken_pcp.svg"
                  } else if (item?.produto?.nome === "Linguiça Salsichão") {
                    imageURL = "./images/pig.svg"
                  } else if (item?.produto?.nome === "Batata Frita") {
                    imageURL = "./images/fries_pcp.svg"
                  }
                  return (
                    <div key={index}>
                      <img src={imageURL} alt="sausage_pcp" />
                      <p>
                        Quantidade: {item?.produtoProd[0]?.quantidadeTotalProduzir}Kg
                        <br />
                        Custo da produção: {item?.produtoProd[0]?.custoTotalProd}
                      </p>
                    </div>
                  )
                })

                }
              </MainRoundContainer>
            </RoundContainer>
          )
        })

        }


        {/* <RoundContainer>
          <H2RoundContainer className="totalsRound">
            TOTAL DE RODADAS
            <img src="./images/icon_playng_game.svg" alt="icon_playng_game" />
          </H2RoundContainer>
          <ParagraphRoundContainer>
            Compra de PRD
            <img src="./images/productions_1.svg" alt="productions_1" />
          </ParagraphRoundContainer>
          <MainRoundContainer>
            <div>
              <img src="./images/sausage_pcp.svg" alt="sausage_pcp" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/chicken_pcp.svg" alt="chicken_pcp" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/fries_pcp.svg" alt="fries_pcp" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
            <div>
              <img src="./images/cut_chicken_pcp.svg" alt="cut_chicken_pcp" />
              <p>
                Quantidade: 100Kg
                <br />
                Custo:
                <br />
                Estoque inicial:
              </p>
            </div>
          </MainRoundContainer>
        </RoundContainer> */}
      </SizeContainer>
    </Container>
  );
};
export default WeeklyReportProduction;
